import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { User, UserLevel } from '@/models/user.model';
import { Mutations, ShiftCMSState } from '@/store';
import { UsersActions, UsersState } from '@/stores/users.store';
import { NEW_ID } from '@/util/constants';
import { computed, onMounted, PropType, reactive, watch } from 'vue';
import { useStore } from 'vuex';


export default /*@__PURE__*/_defineComponent({
  __name: 'UserRequestForm',
  props: {
  data: {
    type: Object as PropType<User>,
  },
},
  setup(__props) {

const store = useStore<ShiftCMSState & { cs: UsersState }>();

const props = __props;

const storeUser = computed<User | null>(() => store.state.cs.user);

const user = reactive<User>({
  id: NEW_ID,
  firstName: '',
  lastName: '',
  deviceID: '',
  email: '',
  level: UserLevel.Device,
  actions: [],
  steps: [],
  stories: [],
  userCo2QuizAnswers: [],
  infographics: [],
  initiatives: [],
  labels: [],
  language: 'nl',
});

watch(
  () => storeUser,
  (v) => {
    Object.assign(user, v);
  },
);

const deleteUser = async () => {
  if (confirm('Are you sure you want to delete this user and all their data')) {
    await store.dispatch(UsersActions.DeleteUser, user);
    store.commit(Mutations.HideDrawer);
    store.dispatch(UsersActions.GetUsers);
  }
};

const deleteUserData = async () => {
  if (confirm(`Are you sure you want to delete this user's data`)) {
    await store.dispatch(UsersActions.DeleteUserData, user);
    store.commit(Mutations.HideDrawer);
    store.dispatch(UsersActions.GetUsers);
  }
};

onMounted(() => {
  if (props.data) {
    Object.assign(user, props.data);

    if (user.id !== NEW_ID) {
      store.dispatch(UsersActions.GetFullUser, user.id);
    }
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      _cache[2] || (_cache[2] = _createElementVNode("h2", null, "Handle the request", -1)),
      _createVNode(_component_v_alert, { type: "warning" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(user.firstName) + " " + _toDisplayString(user.lastName) + " (" + _toDisplayString(user.email) + ") has requested " + _toDisplayString(user.requestedAccountDeletion
          ? 'their account to be deleted'
          : 'their data to be deleted'), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { col: "2" }),
          (user.id !== -1 && user.requestedAccountDeletion)
            ? (_openBlock(), _createBlock(_component_v_col, { key: 0 }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    class: "mt-2",
                    color: "warning",
                    onClick: deleteUser,
                    block: ""
                  }, {
                    default: _withCtx(() => _cache[0] || (_cache[0] = [
                      _createTextVNode("Delete account")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (user.id !== -1 && user.requestedDataRemoval)
            ? (_openBlock(), _createBlock(_component_v_col, { key: 1 }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    class: "mt-2",
                    color: "warning",
                    onClick: deleteUserData,
                    block: ""
                  }, {
                    default: _withCtx(() => _cache[1] || (_cache[1] = [
                      _createTextVNode("Delete data")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_v_col, { col: "2" })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})